import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-upload",
  "use": "icon-leo-upload-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-upload\">\r\n<g transform=\"translate(-86.372 -105.071) scale(1.168696)\">\r\n<path d=\"M448 160h128v352h160L512 768 288 512h160V160z\" />\r\n  <path d=\"M192 832h640v64H192v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-upload.svg
// module id = Khmu
// module chunks = 446